module.exports = __webpack_public_path__ + "img/bg2.97b72d2c.jpg";